import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const breadcrumbNames = {
    courses: "Training",
    services: "Services",
    about: "About",
    contact: "Contact",
  };

  // Handle course detail pages
  const getCourseTitle = (slug) => {
    const courses = {
      "autocad-api": "AutoCAD APIs",
      "solidworks-api": "SolidWorks APIs",
      "nx-open": "NX Open",
      "eyeshot-api": "Eyeshot APIs",
      "inventor-api": "Inventor APIs",
      "rhino3d-api": "Rhino 3D APIs",
      "cad-automation": "CAD Automation",
    };
    return courses[slug] || slug;
  };

  return (
    <nav 
      data-testid="breadcrumb"
      className="flex items-center gap-2 text-sm text-[#0F172A]/60"
    >
      <Link 
        to="/" 
        className="flex items-center gap-1 hover:text-[#2563EB] transition-colors"
        data-testid="breadcrumb-home"
      >
        <Home className="w-4 h-4" />
        <span>Home</span>
      </Link>

      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        const displayName = breadcrumbNames[name] || getCourseTitle(name);

        return (
          <span key={name} className="flex items-center gap-2">
            <ChevronRight className="w-4 h-4" />
            {isLast ? (
              <span className="text-[#0F172A] font-medium">{displayName}</span>
            ) : (
              <Link 
                to={routeTo}
                className="hover:text-[#2563EB] transition-colors"
              >
                {displayName}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
